<template>
  <div class="asc-release-notes-container">
    <v-container fluid>
      <asc-page-header>
        <template #pageTitle><asc-page-title title="RELEASE NOTES" /></template>
      </asc-page-header>
      <asc-release-notes-template
        :release-notes="releaseNotes"
        :loading="isDataLoading && !apiPageFailure.length"
      ></asc-release-notes-template>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AscReleaseNotesTemplate from '@/components/templates/AscReleaseNotesTemplate'
import { USER_CONSTS as UC } from '@/stores/consts'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'

export default {
  name: 'AscReleaseNotesContainer',

  components: {
    AscReleaseNotesTemplate,
    AscPageHeader,
    AscPageTitle,
  },

  data() {
    return {
      isDataLoading: false,
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(UC.NAMESPACE, ['releaseNotes']),
  },

  created() {
    this.getText()
  },

  methods: {
    ...mapActions(UC.NAMESPACE, [UC.GET_RELEASE_NOTES]),
    async getText() {
      this.isDataLoading = true
      await Promise.all([this[UC.GET_RELEASE_NOTES]()])
      this.isDataLoading = false
    },
  },
}
</script>

<style lang="scss">
.asc-release-notes-container {
  background-color: $gray-100;

  .container {
    padding: 16px;
  }
}
</style>
